import { createAsyncAction, createAction } from "typesafe-actions";
import emailSchedulerDefinitionConstants from "store/features/emailScheduler/definition/definition.constants";
import { SchedulerRuleDefinition } from "api/emailScheduler";
import { CreateEmailSchedulerRuleForm } from "validation/components/EmailScheduler/emailSchedulerFormRules";
import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";

const {
    FETCH_SCHEDULER_DEFINITIONS_REQUEST,
    FETCH_SCHEDULER_DEFINITIONS_SUCCESS,
    FETCH_SCHEDULER_DEFINITIONS_FAILED,
    CREATE_SCHEDULER_RULE_REQUEST,
    CREATE_SCHEDULER_RULE_SUCCESS,
    CREATE_SCHEDULER_RULE_FAILED,
    UPDATE_SCHEDULER_RULE_REQUEST,
    UPDATE_SCHEDULER_RULE_SUCCESS,
    UPDATE_SCHEDULER_RULE_FAILED,
    CANCEL_SCHEDULER_RULE_UPDATE,
} = emailSchedulerDefinitionConstants;

export const fetchSchedulerDefinitions = createAsyncAction(
    FETCH_SCHEDULER_DEFINITIONS_REQUEST,
    FETCH_SCHEDULER_DEFINITIONS_SUCCESS,
    FETCH_SCHEDULER_DEFINITIONS_FAILED
)<void, SchedulerRuleDefinition & { exceptions: SchedulerExceptionForm[] }, ErrorHandler>();

export const createSchedulerRule = createAsyncAction(
    CREATE_SCHEDULER_RULE_REQUEST,
    CREATE_SCHEDULER_RULE_SUCCESS,
    CREATE_SCHEDULER_RULE_FAILED
)<CreateEmailSchedulerRuleForm, void, ErrorHandler>();

export const updateSchedulerRule = createAsyncAction(
    UPDATE_SCHEDULER_RULE_REQUEST,
    UPDATE_SCHEDULER_RULE_SUCCESS,
    UPDATE_SCHEDULER_RULE_FAILED
)<CreateEmailSchedulerRuleForm & { id?: string }, void, ErrorHandler>();

export const cancelSchedulerRuleUpdate = createAction(CANCEL_SCHEDULER_RULE_UPDATE)();
